module.exports = __webpack_public_path__ + "static/media/upload.cb1f306a.svg";